var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Site, validateEmail } from '@debbie/common/dist';
import { BlameLogRefType, BlameLogType } from '@debbie/common/dist/blamelog';
import { isAdmin } from '@debbie/common/dist/permissions';
import { selectableRolesForUpdateUser, } from '@debbie/common/dist/users';
import { c, h } from '@debbie/cortex/dist';
import { blameLogs } from '@debbie/cortex/dist/api';
import * as meAPI from '@debbie/cortex/dist/api/me';
import * as usersAPI from '@debbie/cortex/dist/api/users';
import { selectMe, selectRole } from '@debbie/cortex/dist/me/selectors';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors';
import { Modal, PhoneInput } from '..';
import THEME from '../../theme';
import { applyTargetValue, diff } from '../../utils';
import Button from '../Button';
import Checkbox from '../Checkbox';
import { Col, Row } from '../Grid';
import EditIcon from '../Icons/Edit';
import Input from '../Input';
import Messages from '../Messages';
import Panel from '../Panel';
import UserType from '../UserType';
import CreditorSelector from './CreditorSelector';
import { useAllCreditors } from '@debbie/cortex/dist/creditors';
import TenantSelector from './TenantSelector';
const UpdateUserSettings = (props) => {
    var _a;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const meRole = useSelector(selectRole);
    const me = useSelector(selectMe);
    const tenantId = useSelector(selectTenantId);
    const allCreditorsLoadable = useAllCreditors();
    const allCreditors = h.hasData(allCreditorsLoadable)
        ? allCreditorsLoadable.data
        : null;
    const { user, isMe, messages, errors, setMessages, setErrors } = props;
    const [userRole, setUserRole] = useState((tenantId && ((_a = user.tenants.find((t) => t.id === tenantId)) === null || _a === void 0 ? void 0 : _a.role)) ||
        user.role);
    const [firstName, setFirstName] = useState(user.firstName);
    const [lastName, setLastName] = useState(user.lastName);
    const [username, setUsername] = useState(user.username);
    const [email, setEmail] = useState(user.email || '');
    const [phone, setPhone] = useState(user.phone || null);
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [creditors, setCreditors] = useState(user.creditors.map((c) => c.id));
    const [tenants, setTenants] = useState(user.tenants.map((t) => t.id));
    const [todoNotifications, setTodoNotifications] = useState(user.emailPreferences.todoNotifications);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [roleModalOpen, setRoleModalOpen] = useState(false);
    useEffect(() => {
        if (allCreditors != null) {
            setCreditors((creditors) => {
                return creditors
                    .map((c) => (allCreditors !== null && allCreditors !== void 0 ? allCreditors : []).find((ac) => ac.creditorId === c) ? c : null)
                    .filter((c) => !!c);
            });
        }
    }, [allCreditors]);
    useEffect(() => {
        let newErrors = [...errors];
        if (password !== '' && password.length < 8) {
            if (!errors.find((err) => err === lang.users.passwordTooShort)) {
                newErrors.push(lang.users.passwordTooShort);
            }
        }
        else {
            newErrors = newErrors.filter((err) => err !== lang.users.passwordTooShort);
        }
        if (password !== '' &&
            passwordConfirm !== '' &&
            password !== passwordConfirm) {
            if (!errors.find((err) => err === lang.users.passwordsDontMatch)) {
                newErrors.push(lang.users.passwordsDontMatch);
            }
        }
        else {
            newErrors = newErrors.filter((err) => err !== lang.users.passwordsDontMatch);
        }
        setErrors(newErrors);
    }, [password, passwordConfirm]);
    const updateUser = () => {
        var _a;
        const userUpdate = {
            email: email != '' ? email : undefined,
            phone: phone && phone.number != '' ? phone : null,
            username,
            firstName,
            lastName,
            password: password != '' ? password : undefined,
            emailPreferences: {
                todoNotifications: todoNotifications,
            },
            role: (((_a = user.tenants.find((t) => t.id === tenantId)) === null || _a === void 0 ? void 0 : _a.role) !== userRole
                ? userRole
                : undefined),
        };
        const tenantCreditors = user.creditors
            .map((c) => c.id)
            .map((c) => (allCreditors !== null && allCreditors !== void 0 ? allCreditors : []).find((ac) => ac.creditorId === c) ? c : null)
            .filter((c) => !!c);
        const creditorDiff = diff(tenantCreditors, creditors);
        const removeCreditors = Promise.all(creditorDiff.removed.map((id) => usersAPI.removeCreditor(user.id, id)));
        const addCreditors = Promise.all(creditorDiff.added.map((id) => usersAPI.addCreditor(user.id, { id, scopes: [] })));
        const tenantDiff = diff(user.tenants.map((c) => c.id), tenants);
        const removeTenants = Promise.all(tenantDiff.removed.map((id) => usersAPI.removeTenant(user.id, id)));
        const addTenants = Promise.all(tenantDiff.added.map((id) => usersAPI.addTenant(user.id, { id, scopes: [], role: userRole })));
        const updateUser = isMe
            ? meAPI.update(userUpdate)
            : usersAPI.update(user.id, userUpdate);
        Promise.all([
            updateUser,
            addCreditors,
            removeCreditors,
            addTenants,
            removeTenants,
        ])
            .then(() => {
            setMessages([lang.users.userUpdated]);
            setTimeout(() => {
                setMessages([]);
            }, 10000);
            if (site === Site.Caseworker) {
                c.users.getAll();
                c.users.getById(user.id);
            }
            if (isMe) {
                c.me.get();
            }
            for (const tenant of tenants) {
                const blameLog = {
                    details: { userId: user.id },
                    refId: tenant,
                    refType: BlameLogRefType.TenantSettings,
                    type: BlameLogType.UserPasswordUpdate,
                };
                blameLogs.createBlameLog(blameLog, tenant);
            }
        })
            .catch((err) => {
            setErrors([lang.users.updateFailed]);
            setMessages([]);
        });
    };
    const editable = 
    // If you are an admin you can change caseworkers
    (meRole && isAdmin(meRole) && ['caseworker'].includes(user.role)) ||
        // You can always edit yourself
        user.id === (me === null || me === void 0 ? void 0 : me.id) ||
        // Caseworkers and admins can edit clients
        userRole === 'client';
    return (React.createElement(React.Fragment, null,
        React.createElement(Panel, { header: lang.users.userSettings },
            React.createElement(Row, null, props.user.details.meetingAccountType === 'meeting_only' &&
                editable ? null : (React.createElement(UserType, { role: userRole, style: {
                    cursor: !isMe ? 'pointer' : undefined,
                    float: 'right',
                    marginBottom: '10px',
                }, onClick: () => !isMe &&
                    meRole &&
                    meRole === 'admin' &&
                    userRole !== 'client' &&
                    setRoleModalOpen(true), "data-tooltip-id": "tooltip-default", "data-tooltip-content": userRole !== 'client'
                    ? lang.users.changeRoleNotAdmin
                    : lang.users.cantChangeClientRole },
                lang.roles[userRole],
                ' ',
                userRole !== 'client' && !isMe && meRole && isAdmin(meRole) && (React.createElement(EditIcon, null))))),
            React.createElement(Row, null,
                errors.length > 0 ? (React.createElement(Col, { width: "12" },
                    React.createElement(Messages, { messages: errors, type: "error" }))) : null,
                messages.length > 0 ? (React.createElement(Col, { width: "12" },
                    React.createElement(Messages, { messages: messages, type: "success" }))) : null),
            React.createElement(Row, null,
                React.createElement(Col, { width: "12" },
                    React.createElement(Input, { placeholder: lang.users.firstName, disabled: !editable, value: firstName, onChange: applyTargetValue(setFirstName) }),
                    React.createElement(Input, { placeholder: lang.users.lastName, disabled: !editable, value: lastName, onChange: applyTargetValue(setLastName) }),
                    React.createElement(Input, { type: "email", placeholder: lang.users.email, disabled: !editable, value: email, onChange: (e) => {
                            setEmail(e.target.value);
                            setUsername(e.target.value);
                        } }),
                    React.createElement(PhoneInput, { phone: phone, disabled: !editable, placeholder: lang.users.phone, onChange: (phone) => {
                            setPhone(phone);
                        }, noSaveOnValid: true }),
                    userRole === 'client' && (React.createElement(React.Fragment, null,
                        React.createElement(Input, { type: "password", placeholder: lang.users.password, value: password, onChange: applyTargetValue(setPassword), autoComplete: "off" }),
                        React.createElement(Input, { type: "password", placeholder: lang.users.passwordConfirmation, value: passwordConfirm, onChange: applyTargetValue(setPasswordConfirm), autoComplete: "off" }))),
                    userRole === 'client' && site === Site.Caseworker ? (React.createElement(CreditorSelector, { selected: creditors, onSelect: setCreditors })) : null,
                    userRole === 'caseworker' || (userRole === 'admin' && editable) ? (React.createElement(TenantSelector, { selected: tenants, onSelect: setTenants })) : null,
                    props.user.details.meetingAccountType !== 'meeting_only' ? (React.createElement(Checkbox, { placeholder: lang.users.todoNotifications, disabled: !editable, checked: todoNotifications, onChange: (e) => {
                            setTodoNotifications(e.target.checked);
                        } })) : null,
                    editable && (React.createElement(Button, { onClick: updateUser, block: true, disabled: (password !== '' &&
                            (password !== passwordConfirm || password.length < 8)) ||
                            firstName === '' ||
                            lastName === '' ||
                            ((userRole === 'caseworker' || userRole === 'admin') &&
                                tenants.length < 1) ||
                            (email != null && email !== '' && !validateEmail(email)) ||
                            (userRole === 'client' && creditors.length === 0) }, lang.misc.save))))),
        !isMe && meRole && isAdmin(meRole) && (React.createElement(Button, { theme: "dangerous", size: "small", onClick: () => setDeleteModalOpen(!deleteModalOpen) }, lang.users.deleteUser)),
        deleteModalOpen && (React.createElement(Modal, { maxWidth: "400px", header: lang.users.sureYouWantToDeleteUser, onToggle: () => setDeleteModalOpen(!deleteModalOpen) },
            React.createElement(Button, { theme: "dangerous", loading: loading, size: "small", block: true, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    setLoading(true);
                    yield usersAPI.deleteUserById(user.id);
                    yield c.users.getAll();
                    setLoading(false);
                    c.redirect.redirect('/settings/users');
                }) }, lang.users.deleteUserPermanently))),
        roleModalOpen && (React.createElement(Modal, { onToggle: () => setRoleModalOpen(!roleModalOpen), header: lang.users.changeRole, maxWidth: "380px" }, selectableRolesForUpdateUser
            .filter((r) => r !== 'client')
            .map((role) => (React.createElement(RoleSelect, { key: role, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                setUserRole(role);
                setRoleModalOpen(false);
            }) },
            React.createElement(UserType, { role: role }, lang.roles[role]),
            React.createElement("p", null, 
            // @ts-ignore
            lang.rolesDescription[role]))))))));
};
const Wrapper = (props) => {
    const me = useSelector(selectMe);
    const meRole = useSelector(selectRole);
    const users = useSelector((s) => s.users);
    const user = users[props.userId];
    const [messages, setMessages] = useState([]);
    const [errors, setErrors] = useState([]);
    useEffect(() => {
        if (!user) {
            c.users.getById(props.userId);
        }
    }, [props.userId]);
    if (!me)
        return null;
    const isMe = me.id === props.userId;
    if (!meRole)
        return null;
    const u = isMe ? Object.assign(Object.assign({}, me), { role: meRole }) : h.hasData(user) ? user.data : null;
    return me && u && (isMe || h.isLoaded(user)) ? (React.createElement(UpdateUserSettings, { isMe: isMe, messages: messages, setMessages: setMessages, errors: errors, setErrors: setErrors, user: u })) : null;
};
export default Wrapper;
const RoleSelect = styled.div `
  margin: 5px 0;
  cursor: pointer;
  background-color: #e6e6e6;
  border-radius: 2px;
  padding: ${THEME.GRID_SPACING}px;

  &:hover {
    opacity: 0.8;
  }
`;
//# sourceMappingURL=UpdateUserSettings.js.map